import React from 'react';
import { useParams, useHistory } from 'react-router-dom';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Components
import { WpCard, WpCardBody } from 'Wpds/components/card';
import WpButton from 'Wpds/components/button/WpButton';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './EmptyWorkspaceCard.scss';

const EmptyWorkspaceCard = () => {
  const { workspaceId } = useParams();
  const history = useHistory();

  const handleBackToWorkspaceClick = () => {
    history.push(PageUrlsUtils.makeWorkspaceUrl(workspaceId));
  };

  const baseClassName = 'EmptyWorkspaceCard';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__error`}>
        {' '}
        <WpCard centered>
          <WpCardBody padding={0}>
            <div className={`${baseClassName}__error__img`}>
              <WpIllustration
                className={`${baseClassName}__error__img__img`}
                src={Illustrations.three_people_at_table_purple_bg}
                alt="three people sitting at table"
              />
            </div>
          </WpCardBody>
          <WpCardBody>
            <h4 className={`${baseClassName}__error__title`}>Great meetings start with strong agendas</h4>
            <p className={`${baseClassName}__error__description`}>
              Go back to your workspace and add discussion topics to create an agenda for this meeting
            </p>
            <WpButton size="lg" block onClick={handleBackToWorkspaceClick}>
              Back to workspace
            </WpButton>
          </WpCardBody>
        </WpCard>
      </div>
    </div>
  );
};

export default EmptyWorkspaceCard;
